import { call, put } from 'redux-saga/effects';
import {
    requestAddTimeOff,
    requestEditTimeOff,
    requestReviewTimeOff,
    requestDeleteTimeOff,
    requestGetTimeOffSummary,
    requestGetCurrentLeave,
    requestGetPendingTimeOff,
    requestGetCurrentlyOut,
    requestGetTimeOffOverlaps,
} from '../requests/timeoff';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetTimeOffSummary(action) {
    try {
        const { userId, callback } = action.payload;
        const response = yield call(requestGetTimeOffSummary, userId);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleGetCurrentLeave(action) {
    try {
        const { userId, callback } = action.payload;
        const response = yield call(requestGetCurrentLeave, userId);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleGetPendingTimeOff(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetPendingTimeOff);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleGetCurrentlyOut(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetCurrentlyOut);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleGetTimeOffOverlaps(action) {
    try {
        const { userId, startDate, endDate, excludeId, callback } = action.payload;
        const response = yield call(requestGetTimeOffOverlaps, userId, startDate, endDate, excludeId);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback({ error: safeErrorMessage(error) });
    }
}

export function* handleAddTimeOff(action) {
    try {
        const { userId, startDate, endDate, days, type, description, callback } = action.payload;
        const response = yield call(requestAddTimeOff, userId, startDate, endDate, days, type, description);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleEditTimeOff(action) {
    try {
        const { id, startDate, endDate, days, type, description, callback } = action.payload;
        const response = yield call(requestEditTimeOff, id, startDate, endDate, days, type, description);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleReviewTimeOff(action) {
    try {
        const { id, status, callback } = action.payload;
        const response = yield call(requestReviewTimeOff, id, status);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}

export function* handleDeleteTimeOff(action) {
    try {
        const { id, callback } = action.payload;
        const response = yield call(requestDeleteTimeOff, id);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (action.payload?.callback) action.payload.callback({ error: message });
        yield put(showAlert({ severity: 'error', message }));
    }
}
